import { getProductPricing } from './productPricing';

const cleanDetailText = (value = '') =>
  String(value || '')
    .replace(/\s+/g, ' ')
    .replace(/\s+([,.;:!?])/g, '$1')
    .trim();

export const parseProductDetails = (value = '') =>
  String(value || '')
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .map((line) => cleanDetailText(line.replace(/^[-*]\s*/, '')))
    .filter(Boolean)
    .map((line, index) => {
      const labelMatch = line.match(/^([^:]{1,40}):\s*(.+)$/);

      if (labelMatch) {
        return {
          key: `detail-${index}`,
          label: cleanDetailText(labelMatch[1]),
          value: cleanDetailText(labelMatch[2]),
        };
      }

      return {
        key: `detail-${index}`,
        label: '',
        value: line,
      };
    });

export const getDisplayProductDetails = (product = {}) => {
  const details = parseProductDetails(product?.details);
  const { regularPrice, salePrice } = getProductPricing(product);
  const sizes = Array.isArray(product?.sizes) ? product.sizes.join(', ') : '';

  return details.map((detail) => {
    const normalizedLabel = detail.label.toLowerCase().replace(/\s+/g, ' ').trim();

    if (['price', 'selling price', 'sale price'].includes(normalizedLabel)) {
      return { ...detail, value: `KES ${salePrice}` };
    }

    if (['regular price', 'original price'].includes(normalizedLabel)) {
      return { ...detail, value: `KES ${regularPrice}` };
    }

    if (['size', 'sizes', 'available sizes', 'size range'].includes(normalizedLabel)) {
      return { ...detail, value: sizes || 'Ask on WhatsApp' };
    }

    return detail;
  });
};
